import { useEffect, useRef } from "react";
import type { Style } from "mapbox-gl";

import useMap from "./use-map";
import useDeepCompare from "@alpaca-travel/utils/use-deep-compare";

const useMapStyleDiffApply = (currentStyle?: Style | null) => {
  const mounted = useRef(true);

  const { map } = useMap();

  const latestMapStyle = useDeepCompare(currentStyle);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  // Apply when changes
  const mapAvailable = useRef(false);
  useEffect(() => {
    let isEffectStillMounted = true;

    if (mounted.current) {
      try {
        if (
          map &&
          (map.isStyleLoaded() || mapAvailable.current) &&
          latestMapStyle
        ) {
          mapAvailable.current = true;
          map.setStyle(latestMapStyle);
        } else if (map && latestMapStyle) {
          // Wait for the map to load before applying the next differences
          const callback = () => {
            if (isEffectStillMounted === true) {
              mapAvailable.current = true;
              map.setStyle(latestMapStyle);
            }
          };
          map.once("load", callback);
          return () => {
            map.off("load", callback);
            isEffectStillMounted = false;
          };
        }
      } catch (e: any) {
        console.warn(e);
      }
    } else {
      console.warn("Ignoring this map style update");
    }
  }, [map, latestMapStyle]);

  return null;
};

export default useMapStyleDiffApply;
